export const SET_LOGIN_FIELD = 'SET_LOGIN_FIELD'